<template>
    <div class="modal fade" id="modal-playAudio" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content filter-content">


                <div class="modal-header">
                    <h4>Recado {{ recado.id }}</h4>
                    <button type="button" class="close" @click="close">&times;</button>
                </div>
                <div class="modal-body">
                    <div>
                    <Loading  v-if="loading_audio" />
                <player ref="wavesurfer" :class="(!audio.hash) ? 'hidden' : ''" :audio_hash="audio.hash" />
            </div>
</div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/mixins/api.js"
import replace from "@/mixins/replace.js"
import player from "@/components/Tools/Player"

export default {
    name: 'modal-playAudio',
    props: ['recado'],
    mixins: [api, replace],
    components: { player },

    data: () => {
        return {

            loading_audio: false,
            audio: { hash: null, path: null, transcricao: null },

        }
    },

    watch: {
			recado() { 
				
				this.load_data()
			}
		},


    methods: {
        async load_data() {
            this.audio.hash = null;
            this.load_audio();
        },

        async load_audio() {
            const response = await this.GET("Audio", this.recado.gravacao_id);
            this.audio.path = response.path;

            if ((response.file == "" || response.file == null) && response.path != null) {
                this.carrega_audio(response.path);
            } else {
                this.audio.hash = response.file;
            }
        },

        async carrega_audio(caminho) {

            if (!caminho) {
                this.audio.hash = null;
                this.loading_audio = false;
            } else {
                this.loading_audio = true;
                const response = await this.POST("Audio/pegaAudio", { path: caminho });
                if (this.loading_audio) {
                    this.audio.hash = response;
                }
                this.loading_audio = false;
            }
        },

        close() {
            this.$emit('close');
            $("#modal-playAudio").modal('hide');
        }
    }
}
</script>

<style scoped>

.modal-content{
    width: 125%;
    background: snow;
}

.modal-header{
    border-bottom: 1px solid #147F75;
}
</style>